import {parseOptions, useLazyGetAssetsRelatedOptionsForInfiniteScrollingQuery,} from '../../../../redux/api/assets';
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {OptionLabelValue} from '../../../../types/internal/OptionLabelValue';
import {capitalize} from 'lodash';
import {getTranslationAssetTableColumnKey} from '../../../../utils/translation';
import {useTranslation} from 'react-i18next';
import {titleCase} from '../../../../utils/parser';
import {
  AssetsFiltersFE,
  fromFeToBeAssetsFilters,
  StaticAssetsFilters
} from "../../../../types/internal/tables/assetsTable";
import NEWListWithSearchFilter from "../../../common/filters/NEWListWithSearchFilter";
import {AssetsOptionLabelValueFilters} from "../../../../types/internal/tables/assetsTable";
import {useParams} from "react-router-dom";

interface AssetRelatedOptionsFilterCreationAreasProps {
  field:
    'acoustic_zone'
    | 'address'
    | 'admin_level_1'
    | 'admin_level_2'
    | 'admin_level_3'
    | 'building_type'
    | 'building_type_detail'
    | 'companies',
  filters: AssetsFiltersFE,
  filtersInExcludeMode: AssetsOptionLabelValueFilters[],
  addFilters: (addFilters: AssetsFiltersFE) => void,
  removeFilters: (removeFilters: ((StaticAssetsFilters | 'hazards') | string)[] | ((StaticAssetsFilters | 'hazards') | string)) => void,
  insertFilterInExcludeMode: (filterInExcludeMode: AssetsOptionLabelValueFilters) => void,
  removeFilterInExcludeMode: (filterInExcludeMode: AssetsOptionLabelValueFilters) => void,
}
export default function AssetRelatedOptionsFilterCreationAreas({
  field,
  filters,
  filtersInExcludeMode,
  addFilters,
  removeFilters,
  insertFilterInExcludeMode,
  removeFilterInExcludeMode
}: AssetRelatedOptionsFilterCreationAreasProps) {
  const [getData, {
    data,
    isLoading,
    isFetching,
    isUninitialized,
    originalArgs,
  }] = useLazyGetAssetsRelatedOptionsForInfiniteScrollingQuery()
  const [querySearch, setQuerySearch] = useState<string>('');
  const options: OptionLabelValue[] = useMemo(() => parseOptions(data?.results || []).map(el =>
      ['address', 'admin_level_1', 'admin_level_3'].includes(field) ?
        {...el, label: el.label ? titleCase(el.label) : ''}
        : el),
    [data?.results, field]);
  const total = data?.count || 0;
  const {t} = useTranslation();
  const {uuid} = useParams()
  const placeholder = capitalize(t('table.filterPlaceholder', {column: t(getTranslationAssetTableColumnKey(field))}));

  const assetsTableFiltersWithoutCurrentFilterRef = useRef<AssetsFiltersFE>({})
  const selectedFilters = filters[field] || [];
  const isExclude = filtersInExcludeMode.some(el => el === field)

  useEffect(() => {
    const {[field]: currentFilter, ...otherFilters} = filters
    assetsTableFiltersWithoutCurrentFilterRef.current = otherFilters
  }, [filters, field]);


  const handleGetNext = useCallback(() => {
    getData({
      column: field,
      ...!!querySearch && {column_search: querySearch},
      ...fromFeToBeAssetsFilters(assetsTableFiltersWithoutCurrentFilterRef.current, filtersInExcludeMode),
      page: (originalArgs?.page || 0) + 1,
      page_size: 15,
      event_uuid: uuid
    });
  }, [field, filtersInExcludeMode, getData, originalArgs?.page, querySearch, uuid]);

  useEffect(() => {
    getData({
      column: field,
      ...!!querySearch && {column_search: querySearch},
      ...fromFeToBeAssetsFilters(assetsTableFiltersWithoutCurrentFilterRef.current, filtersInExcludeMode),
      page: 1,
      page_size: 15,
      event_uuid: uuid
    });
  }, [field, filtersInExcludeMode, getData, querySearch, uuid]);

  return <>
    <NEWListWithSearchFilter
      getNext={handleGetNext}
      options={options}
      selectedOptions={selectedFilters}
      setSelectedOptions={values => {
        if (values.length) {
          addFilters({[field]: values});
        } else {
          removeFilters(field);
        }
      }}
      total={total}
      isLoadingOptions={isLoading || isFetching || isUninitialized}
      querySearch={querySearch}
      setQuerySearch={setQuerySearch}
      search={{placeholder}}
      isExcludeFeature={true}
      isExclude={isExclude}
      setExcludeMode={() => {
        insertFilterInExcludeMode(field);
        removeFilters(field);
      }}
      setDeclarativeMode={() => {
        removeFilterInExcludeMode(field);
        removeFilters(field);
      }}
    />
  </>;
}
